'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';
import 'bootstrap';

import { tr, lang } from '../../utils/helpers';

const challengesShow = {
  init() {
    if (sessionStorage.openShareModal == 'S') {
      $('#share-btn').trigger('click');
    }

    $('.js-additional-check').on('change', function (e) {
      if ($('#' + $(this).attr('data-id')).hasClass('u-display--none')) {
        $('#' + $(this).attr('data-id')).removeClass('u-display--none');
      } else {
        $('#' + $(this).attr('data-id')).addClass('u-display--none');
        $('#' + $(this).attr('data-id'))
          .find('input:text')
          .val('');
      }
    });

    $('.js-copy').on('click', function (e) {
      e.preventDefault();

      var range, selection, worked;
      var element = document.getElementById('challenge-link');

      if (document.body.createTextRange) {
        range = document.body.createTextRange();
        range.moveToElementText(element);
        range.select();
      } else if (window.getSelection) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
      }

      try {
        document.execCommand('copy');
        alert('Link copiado');
      } catch (err) {
        alert('unable to copy text');
      }
    });

    $('.js-modal-gallery').on('click', function () {
      Swal.fire({
        html: `<h3 class="o-ttl u-m-b-20">${tr[lang].title_images_gallery}</h3><p>${tr[lang].text_no_images_added}</p>`,
        padding: '25px 15px',
        position: 'top',
        showConfirmButton: false,
        showClass: {
          popup: 'c-new-swal--popup',
        },
        customClass: 'c-new-swal',
      });
    });

    $('.js-modal-materials').on('click', function () {
      Swal.fire({
        html: `<h3 class="o-ttl u-m-b-20">${tr[lang].title_aditional_materials}</h3><p>${tr[lang].text_no_materials_added}</p>`,
        padding: '25px 15px',
        position: 'top',
        showConfirmButton: false,
        showClass: {
          popup: 'c-new-swal--popup',
        },
        customClass: 'c-new-swal',
      });
    });
  },
};

export default challengesShow;
